// Module
var code = `
<div class="breadcrumb-content">
  <h4>SpyneJS Design System</h4>
  <ol class="breadcrumbs-list"></ol>
</div>
`;
// Exports
module.exports = code;